export const ADD_TASK = 'ADD_TASK'
export const DELETE_TASK = 'DELETE_TASK'
export const COMPLETE_TASK = 'COMPLETE_TASK'
export const ORDER_MOST_RECENT = 'order_most_recent'
export const ORDER_LEAST_RECENT = 'order_least_recent'


/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/